import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import cn from 'comma-number'
// import { scroller } from 'react-scroll'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import AppLink from 'Components/AppLink'
import { RENT, API_ADMIN_URL } from 'Defaults'
import { BlurCont } from 'Layout'
import SvgIcon from 'Components/SvgIcon'
import ToolTipV2 from 'Components/ToolTipV2'
import ListingRemovalMessage from 'Components/ListingRemovalMessage'
import EstimateAnimation from 'Components/EstimateAnimation'
import { BuyVsRentCalculator, MortgageCalculator } from 'Components'
import { THEME_NAME } from 'Config/config'
import { MODAL_TYPE, SL_GATE } from 'Defaults/modals'
import { scrollToCollapsible } from 'Utils/navigationUtils'
import ListedAgo from '../ListedAgo'
import { MortgageCTA } from '../MortgageCTA'

import {
  _ContentContainer, _LeftBlock, _ListedAgo, _PlaceholderOffer, _PlaceholderListedAgo,
  _Details, _ParkingDetails, _RightBlock, _InstantEstimate, _NoInstantEstimate,
  _PlaceholderPrice, _Price, _Calculator, _CalcInner, _CloseCalcCta, _AdminIcon, _AdminIconList,
  _HiddenFieldMessage, _DetailFiller, _ListedAgoGroup, _Offer, _LeftBottomRow, _BedDetails, _BathDetails, _SqftDetails,
  _RightBlockContainer, _Asterisk, _Disclaimer, _ListedPrice, _DirectionContainer, _DirectionLink,
  _DesktopPriceBlock, _MobilePriceBlock, _EstimateLogin, _OpenHouseAppCTA, _OpenHouseText, _PropertyTypeDetails,
} from './styles.js'

class ListingInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isCalcOn: false,
      renderCalc: false,
      bannerKeys: {
        5: 'Leased conditional',
        8: 'Sold conditional',
      },
      isEstimateTooltipOn: false,
      isClientSideRendered: false,
    }
    this.toggleCalc = this.toggleCalc.bind(this)
    this.renderPriceBlock = this.renderPriceBlock.bind(this)
    this.hoverCalcCta = this.hoverCalcCta.bind(this)
    this.onContactAgentClick = this.onContactAgentClick.bind(this)
    this.generateStatusBlock = this.generateStatusBlock.bind(this)
    this.renderRightBlock = this.renderRightBlock.bind(this)
  }

  componentDidMount() {
    this.setState({ isClientSideRendered: true })
  }

  onContactAgentClick() {
    this.props.handleContactAgentClick('Listing Removal Text', this.props.agent)
  }

  hoverCalcCta() {
    const isForRent = this.props.listing && this.props.listing.offer === RENT
    if(!this.state.renderCalc) this.setState({ renderCalc: true })
    if(isForRent) {
      BuyVsRentCalculator.preload()
    } else {
      MortgageCalculator.preload()
    }
  }

  toggleCalc() {
    if(!this.props.listing) return null
    this.setState({ isCalcOn: !this.state.isCalcOn })
    const offer = this.props.listing.offer
    this.props.googleAnalyticsEvent({
      category: 'listing',
      action: `[${offer} Mortgage Calc Click]`,
    })
    this.props.googleAnalyticsEvent({
      category: 'listing',
      action: `[${offer} Mortgage Calc Click][${
        !this.state.isCalcOn ? 'Open' : 'Close'
      }]`,
    })
  }

  renderAdminButtons(listing, userIsAdmin, userIsAgent, userIsAgentSupport, isArchived) {
    const buttons = []
    const listingId = (listing && listing.id) || null
    const buildingId =
      (listing && listing.building && listing.building.id) || null
    if(typeof window !== 'undefined') {
      if(userIsAgent || userIsAdmin || userIsAgentSupport) {
        const mlsNumber = (listing && listing.mls_number) || null
        if(mlsNumber) {
          buttons.push(
            <_AdminIcon key={'printListing'}>
              <AppLink
                openNewTab
                alt={'Print Listing'}
                aria-label="Print Listing"
                to={`/print/listings/${mlsNumber}`}
              >
                <SvgIcon name="#icon-printer" width={25} height={25} aria-label="Print Listing" />
              </AppLink>
            </_AdminIcon>,
          )
        }
      }
      if(userIsAdmin) {
        if(listingId) {
          const editListingUrl = isArchived
            ? `${API_ADMIN_URL}archive-listings/${listingId}/general`
            : `${API_ADMIN_URL}listing/${listingId}/general`

          buttons.push(
            <_AdminIcon key={'adminListing'}>
              <AppLink openNewTab alt={'Edit Listing'} to={editListingUrl}>
                <SvgIcon name="#icon-edit" width={25} height={25} />
              </AppLink>
            </_AdminIcon>,
          )
        }
        if(buildingId) {
          buttons.push(
            <_AdminIcon key={'adminBuilding'}>
              <AppLink
                openNewTab
                alt={'Edit Building'}
                to={`${API_ADMIN_URL}building/${buildingId}/general`}
              >
                <SvgIcon name="#icon-buildings" width={25} height={25} />
              </AppLink>
            </_AdminIcon>,
          )
        }
      }
    }
    return <_AdminIconList>{buttons}</_AdminIconList>
  }


  renderPriceBlock() {
    const { listing, listingIsLocked, hiddenFields, isPrecon } = this.props
    const { closed_price: closedPrice, banner_id: bannerId, asking_price: askingPrice } = listing || {}
    const formattedClosedPrice = closedPrice
      ? '$' + cn(closedPrice)
      : closedPrice
    const isAskingPriceAvailable = Number.isFinite(askingPrice) && askingPrice > 0
    const formattedAskingPrice = isAskingPriceAvailable ? `$${cn(askingPrice)}` : 'Contact for pricing'

    if(hiddenFields.prices) {
      return (
        <_Price
          priceHidden={hiddenFields.prices}
        >
          <div>Price Not Available</div>
        </_Price>
      )
    } if(formattedClosedPrice) {
      return (
        <_Price
          soldStatus={!!formattedClosedPrice}
        >
          {listing.offer === 'Sale' ?
            <div>Sold for <BlurCont blur={listingIsLocked}>{formattedClosedPrice}</BlurCont></div> :

            <div><span>Leased for <BlurCont blur={listingIsLocked}>{formattedClosedPrice}</BlurCont> </span></div> }
          <_ListedPrice><span>Listed for <BlurCont blur={listingIsLocked}>{formattedAskingPrice}</BlurCont></span></_ListedPrice>
        </_Price>
      )
    } if(bannerId === 8 || bannerId === 5) {
      return (
        <_Price soldStatus={!!bannerId} conditionalStatus={!!bannerId}>
          <div>  <BlurCont blur={listingIsLocked}> {this.state.bannerKeys[bannerId]}</BlurCont> </div>
          <_ListedPrice>Listed for&nbsp;<BlurCont blur={listingIsLocked}>{formattedAskingPrice}</BlurCont></_ListedPrice>
        </_Price>
      )
    }
    return (
      <_Price nowrap={isPrecon && !isAskingPriceAvailable}>
        <BlurCont blur={listingIsLocked}>
          {isPrecon && listing?.property_type === 'Floorplan' && isAskingPriceAvailable ?
            `From ${formattedAskingPrice}` : formattedAskingPrice}
        </BlurCont>
      </_Price>
    )
  }


  generateStatusBlock = (listing, listingIsLocked) => {
    const { offer, status, end_date: endDate, banner_id: bannerId } = listing || {}
    const { hiddenFields } = this.props
    if(bannerId === 8 || bannerId === 5) {
      return this.state.bannerKeys[bannerId]
    }
    if(status === 'Active') {
      return (
        <>For {offer === 'Precon' ? 'Sale' : offer}</>
      )
    } if(endDate) {
      return (endDate === 'Login Required' ?
        endDate :
        <>
          {status}&nbsp;on&nbsp;
          <BlurCont blur={listingIsLocked || hiddenFields?.listing_info}>{
            format(parseISO(endDate), 'MMM d, y')}
          </BlurCont>
        </>
      )
    }
    return <BlurCont blur={listingIsLocked || hiddenFields?.listing_info}>{status}</BlurCont>
  }

  renderRightBlock = ({ isForRent, mobileView }) => (
    <_RightBlock>
      <_RightBlockContainer isPrecon={this.props.isPrecon}>
        {this.props.listing ? (
          this.renderPriceBlock()
        ) : (
          <_PlaceholderPrice />
        )}


        {
          !(this.props.showEstimate && !this.props.isPrecon) ?
            '' :
            this.props.userIsAuthentificated && this.props.listing?.listing_estimate?.prediction?.expected ?
              <_InstantEstimate
                onClick={() => {
                  scrollToCollapsible({
                    section: this.props.navigationLinks.estimate + this.props.collapsibleIdSuffix,
                    offset: -100,
                    containerId: this.props.pageModalLevel ? `appModalPage-${this.props.pageModalLevel}` : null,
                  })
                  this.props.googleAnalyticsEvent({
                    category: 'listing',
                    action: '[Instant Estimate Cliked]',
                  })
                }}
                onMouseEnter={() => {
                  if(!this.state.isEstimateTooltipOn) {
                    setTimeout(() => {
                      this.setState({ isEstimateTooltipOn: true })
                    }, 1000)
                  }
                }}
                onMouseLeave={() => {
                  if(this.state.isEstimateTooltipOn) {
                    this.setState({ isEstimateTooltipOn: false })
                  }
                }}
              >
                <EstimateAnimation />
                Instant Estimate:&nbsp;<span>${cn(this.props.listing?.listing_estimate?.prediction?.expected)}</span>

                <SvgIcon name="#icon-arrow-final" width={8} height={11} className={'estimateArrow'} />

                {
                !mobileView && this.props.winWidth > 768 ?
                  <ToolTipV2
                    title={'About our Instant Estimate'}
                    body={
                      'This listing\'s value estimate is powered by advanced algorithms and extensive real' +
                      ' estate market data, providing you with a precise and data-driven market valuation.'
                    }
                    withCloseBtn={false}
                    defaultVisible={this.state.isEstimateTooltipOn}
                  />
                  : ''
              }
              </_InstantEstimate>
              : !this.props.listing?.listing_estimate?.prediction?.expected ?
                <_NoInstantEstimate>Instant Estimate Not Available</_NoInstantEstimate>

                :
                <_EstimateLogin
                  secondary
                  medium
                  onClick={
                () => {
                  this.props.openModal({
                    modalType: MODAL_TYPE.LOGIN,
                    modalSource: 'listing',
                    modalData: { gate: SL_GATE.ACTIVE_LISTING_ESTIMATE },
                  })

                  this.props.googleAnalyticsEvent({
                    category: 'listing',
                    action: '[Listing info Estimate Login clicked]',
                  })
                }

              }
                >
                  Log in to view instant estimate
                </_EstimateLogin>
        }

        {
          !this.props.hiddenFields?.prices && (
            <MortgageCTA
              text={isForRent ? 'Rent vs Buy Calculator' : 'Mortgage Calculator'}
              iconSrc={!isForRent ? '#icon-buy-calculator' : '#icon-rent-calculator'}
              navigationLinks={this.props.navigationLinks}
              collapsibleIdSuffix={this.props.collapsibleIdSuffix}
              pageModalLevel={this.props.pageModalLevel}
            />
          )
        }
      </_RightBlockContainer>
    </_RightBlock>
  )

  render() {
    const {
      listing,
      isFetchingListing,
      userIsAuthentificated,
      userIsAdmin,
      userIsAgent,
      googleAnalyticsEvent,
      openModal,
      userIsAgentSupport,
      isArchived,
      hiddenFields,
      hasAnyHiddenFields,
      isUserAgentAdminSupport,
      listingIsLocked,
      isMobile,
      openHouses,
      isPrecon,
    } = this.props
    const { isCalcOn, renderCalc, isClientSideRendered } = this.state

    const {
      title,
      entry_date: entryDate,
      entry_date_unix: entryDateUnix,
      end_date: endDate,
      sqft: actualSqft,
      status,
      property_type: propertyType,
    } = listing || {}
    const isForRent = listing && listing.offer === RENT
    const activeListing = status === 'Active'
    return (
      <Fragment>
        <_ContentContainer>
          <_ListedAgoGroup>
            <_LeftBlock>
              <div>
                {
                  // Exception: this message should show regardless of role
                  hasAnyHiddenFields ? (
                    <_HiddenFieldMessage>
                      <_LeftBlock>
                        <ListingRemovalMessage
                          hideContactAgentText={isUserAgentAdminSupport}
                          onContactAgentClick={this.onContactAgentClick}
                          hiddenFields={listing.hidden_fields}
                          requireBackground
                        />
                      </_LeftBlock>
                    </_HiddenFieldMessage>
                  ) :
                    <_Details isPrecon={isPrecon}>

                      {!hiddenFields.listing_info && listing && listing.bed_type ? (
                        <div>
                          <_BedDetails>
                            <SvgIcon name="#icon-beds" width={24} height={20} />
                            <span>
                              <BlurCont blur={listingIsLocked}>
                                {listing.bed_type}
                              </BlurCont>
                              &nbsp;
                              {listing.bed_type !== 'Studio' ? 'bed' : ''}
                            </span>
                          </_BedDetails>
                          <_BathDetails>
                            <SvgIcon name="#icon-bath" width={24} height={20} />
                            <span>
                              <BlurCont blur={listingIsLocked}>
                                <span>{listing.bathrooms}</span>
                              </BlurCont>

                            &nbsp;bath
                            </span>
                          </_BathDetails>
                          {!isPrecon &&
                            <_ParkingDetails>
                              <SvgIcon name="#icon-parking" width={24} height={20} />
                              <span>
                                <BlurCont blur={listingIsLocked}>
                                  <span>{listing.parking_spots || '0'}   </span>
                                </BlurCont>
                                &nbsp;parking
                              </span>
                            </_ParkingDetails>
                          }

                          <_SqftDetails isPrecon={isPrecon}>
                            <SvgIcon name="#icon-size" width={24} height={20} />
                            <span>
                              <BlurCont blur={listingIsLocked}>
                                <span>
                                  {actualSqft ?
                                    `${actualSqft}` : (listing?.sqft_min && listing?.sqft_max) ?
                                      `${listing.sqft_min} - ${listing.sqft_max}` : '-'}
                                </span>

                              </BlurCont>
                                  &nbsp;sqft

                              {
                                isClientSideRendered && actualSqft && !isMobile && !isPrecon ?
                                  (<_Asterisk>&nbsp;*</_Asterisk>) : ''
                              }
                            </span>
                            {
                              (isClientSideRendered && isMobile && !isPrecon) && (
                                <ToolTipV2
                                  body={
                                    `This unit size is calculated from ${THEME_NAME}.ca data`
                                  }
                                  triggerSize={12}
                                  withCloseBtn
                                  parentIdSuffix={this.props.collapsibleIdSuffix}
                                />
                              )
                            }
                          </_SqftDetails>
                          {
                            !isPrecon &&
                              <_PropertyTypeDetails>
                                <SvgIcon name="#icon-property-type" width={24} height={20} />
                                <span>
                                  <BlurCont blur={listingIsLocked}>
                                    <span>{propertyType || '-'}   </span>
                                  </BlurCont>
                                </span>
                              </_PropertyTypeDetails>
                          }
                        </div>
                      ) : <_DetailFiller />}
                    </_Details>
                }
                {this.renderAdminButtons(
                  listing,
                  userIsAdmin,
                  userIsAgent,
                  userIsAgentSupport,
                  isArchived,
                )}

                {
                  (actualSqft && !isPrecon) ? (
                    <_Disclaimer desktop>
                      <_Asterisk>*</_Asterisk>&nbsp;This unit size is calculated from {THEME_NAME}.ca data
                    </_Disclaimer>
                  ) : ''
                }
              </div>

              <_MobilePriceBlock>
                {this.renderRightBlock({ isForRent, mobileView: true })}
              </_MobilePriceBlock>


              <_LeftBottomRow activeListing={activeListing}>

                <_Offer endDate={endDate}>
                  {!listing && isFetchingListing ? (<_PlaceholderOffer />) : (this.generateStatusBlock(listing, listingIsLocked))}
                </_Offer>


                {isPrecon && (listing?.property_type === 'Floorplan') &&
                  <_Offer>
                    Floorplan
                  </_Offer>
                }
                {isPrecon && (listing?.property_type === 'Unit') &&
                  <_Offer>
                    Unit
                  </_Offer>
                }
                {!isPrecon && (
                  <_ListedAgo hidden={hiddenFields.listing_info} activeListing={activeListing}>
                    {!listing && isFetchingListing ? (<_PlaceholderListedAgo />) :
                      (<ListedAgo
                        listingIsLocked={listingIsLocked}
                        entryDateUnix={entryDateUnix}
                        entryDate={entryDate}
                        endDate={endDate}
                        userIsAuthentificated={userIsAuthentificated}

                      />)}
                  </_ListedAgo>
                )}
              </_LeftBottomRow>

            </_LeftBlock>
          </_ListedAgoGroup>

          <_DesktopPriceBlock>
            {this.renderRightBlock({ isForRent })}
          </_DesktopPriceBlock>
        </_ContentContainer>

        {
          (actualSqft && !isPrecon) ? (
            <_Disclaimer>
              <_Asterisk>*</_Asterisk>&nbsp;This unit size is calculated from {THEME_NAME}.ca data
            </_Disclaimer>) : ''
        }


        {
          !hiddenFields.prices && (
            <_Calculator
              data-test-id="calculatorSection"
              buyVsRent={isForRent}
              visible={isCalcOn}
            >
              {
                listing && (isCalcOn || renderCalc) ?
                  <_CalcInner>
                    {
                      isForRent ?
                        <BuyVsRentCalculator
                          address={title}
                          rent={listing.asking_price}
                          googleAnalyticsEvent={googleAnalyticsEvent}
                          user={this.props.user}
                          listingId={listing.id}
                          mls={listing.mls_number}
                        />
                        :
                        <MortgageCalculator
                          address={title}
                          googleAnalyticsEvent={googleAnalyticsEvent}
                          price={listing.asking_price}
                          maintenance={listing.maintenance_fee}
                          tax={listing.tax}
                          openModal={openModal}
                          user={this.props.user}
                          listingId={listing.id}
                          mls={listing.mls_number}
                        />
                    }
                  </_CalcInner>
                  : null
              }
              <_CloseCalcCta onClick={this.toggleCalc}>
                <SvgIcon name="#icon-close" width={15} height={15} />
              </_CloseCalcCta>
            </_Calculator>
          )
        }

        <_DirectionContainer onClick={this.props.openPhotosAndLocation}>
          <img
            src="/static/images/map/direction-cta.webp"
            alt="Click to open the pre-gallery to get the direction"
          />
          <_DirectionLink>Get Directions</_DirectionLink>
        </_DirectionContainer>
        {
          this.props.isMobileApp && openHouses?.length > 0 ?
            (
              <_OpenHouseAppCTA onClick={this.props.openHouseModal}>
                <SvgIcon name="#icon-openhouse" width={17} height={15}/>
                <_OpenHouseText>View Open House Times
                  <span>
                    {openHouses.length} Available
                  </span>
                </_OpenHouseText>
              </_OpenHouseAppCTA>
            ) : ''
        }
      </Fragment>
    )
  }
}

ListingInfo.defaultProps = {
  googleAnalyticsEvent: () => {},
  hiddenFields: {},
}

ListingInfo.propTypes = {
  listing: PropTypes.shape({
    open_houses: PropTypes.arrayOf(PropTypes.shape({})),
    offer: PropTypes.string,
    created_at: PropTypes.string,
    bed_type: PropTypes.string,
    bathrooms: PropTypes.number,
    parking_spots: PropTypes.number,
    property_type: PropTypes.string,
    asking_price: PropTypes.number,
    tax: PropTypes.number,
    maintenance_fee: PropTypes.string,
    tax_year: PropTypes.number,
    title: PropTypes.string,
    id: PropTypes.number,
    mls_number: PropTypes.string,
    hidden_fields: PropTypes.shape({
      photos: PropTypes.bool,
      prices: PropTypes.bool,
      listing_info: PropTypes.bool,
    }),
    sqft: PropTypes.number,
    sqft_min: PropTypes.number,
    sqft_max: PropTypes.number,
    listing_estimate: PropTypes.shape({
      prediction: PropTypes.shape({
        expected: PropTypes.number,
      }),
    }),
  }),
  listingIsLocked: PropTypes.bool,
  isFetchingListing: PropTypes.bool,
  // userIsAuthentificated: PropTypes.bool,
  userIsAdmin: PropTypes.bool,
  userIsAgent: PropTypes.bool,
  userIsAgentSupport: PropTypes.bool,
  googleAnalyticsEvent: PropTypes.func,
  openModal: PropTypes.func,
  isArchived: PropTypes.bool,
  hasAnyHiddenFields: PropTypes.bool,
  isUserAgentAdminSupport: PropTypes.bool,
  agent: PropTypes.shape({}),
  handleContactAgentClick: PropTypes.func,
  hiddenFields: PropTypes.shape({
    photos: PropTypes.bool,
    prices: PropTypes.bool,
    listing_info: PropTypes.bool,
  }),
  userIsAuthentificated: PropTypes.bool,
  openPhotosAndLocation: PropTypes.func,
  navigationLinks: PropTypes.shape({
    estimate: PropTypes.string,
  }),
  showEstimate: PropTypes.bool,
  collapsibleIdSuffix: PropTypes.string,
  pageModalLevel: PropTypes.number,
  winWidth: PropTypes.number,
  openHouseModal: PropTypes.func,
  isMobileApp: PropTypes.bool,
  isMobile: PropTypes.bool,
  openHouses: PropTypes.arrayOf(PropTypes.shape({})),
  user: PropTypes.shape({
    id: PropTypes.number,
  }),
  isPrecon: PropTypes.bool,
}

export default ListingInfo
